// frontend/src/hooks/useShiftStatus.js
//
// Polls GET /api/v1/shifts/mine/current every 30s so the top-nav
// ShiftClockWidget reflects "you're still clocked in" across reloads and
// panel switches. Same short-polling shape as useNotifications.js — this
// Worker has no WebSockets.
import { useEffect, useRef, useState, useCallback } from 'react';
import { apiFetch } from '../api/client';

const POLL_MS = 30000;

export function useShiftStatus({ active = true } = {}) {
  const [shift, setShift] = useState(null);
  const [loading, setLoading] = useState(true);
  const timerRef = useRef(null);

  const poll = useCallback(async () => {
    try {
      const res = await apiFetch('/shifts/mine/current');
      if (!res.ok) return;
      const data = await res.json().catch(() => ({}));
      if (!data || !data.success) return;
      setShift(data.shift || null);
    } catch {
      /* network blip — keep the last known state */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!active) return undefined;
    poll();
    timerRef.current = setInterval(poll, POLL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [active, poll]);

  return { shift, loading, refresh: poll };
}
